import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';

import ArticleLayout from './ArticleLayout';
import { ArticleProps } from './interfaces';

const Article = (props: ArticleProps) => {
  const queryClient = new QueryClient();

  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <ArticleLayout {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Article;
